<div class="page-container">
  <a class="back-link" routerLink="/organisers">
    <i nz-icon nzType="arrow-left" aria-hidden="true"></i> All Organisers
  </a>

  <nz-spin [nzSpinning]="loading">
    <div *ngIf="organiser" class="profile-layout">
      <!-- Profile Header -->
      <div class="profile-header">
        <div class="profile-avatar">{{ getInitial(organiser.name) }}</div>
        <div class="profile-info">
          <h1 class="profile-name">{{ organiser.name }}</h1>
          <div class="profile-meta">
            <span *ngIf="organiser.organiserCategory" class="meta-badge">{{ organiser.organiserCategory }}</span>
            <span *ngIf="organiser.city" class="meta-item">
              <i nz-icon nzType="environment" aria-hidden="true"></i>
              {{ organiser.city }}<span *ngIf="organiser.country">, {{ organiser.country }}</span>
            </span>
          </div>
          <div class="profile-stats">
            <span class="stat"><strong>{{ followerCount }}</strong> followers</span>
            <span class="stat"><strong>{{ upcomingEvents.length }}</strong> upcoming events</span>
            <span class="stat" *ngIf="organiserEvents.length > 0"><strong>{{ organiserEvents.length }}</strong> total events</span>
          </div>
        </div>
        <button
          nz-button
          [nzType]="isFavourite ? 'default' : 'primary'"
          [nzLoading]="favouriteLoading"
          (click)="toggleFavourite()"
          class="follow-btn"
        >
          <i nz-icon [nzType]="isFavourite ? 'heart' : 'heart'" [nzTheme]="isFavourite ? 'fill' : 'outline'" aria-hidden="true"></i>
          {{ isFavourite ? 'Following' : 'Follow' }}
        </button>
      </div>

      <!-- About -->
      <div class="section" *ngIf="organiser.description">
        <h2 class="section-title">About</h2>
        <p class="about-text">{{ organiser.description }}</p>
      </div>

      <!-- Contact & Socials -->
      <div class="section">
        <h2 class="section-title">Contact</h2>
        <div class="contact-grid">
          <div class="contact-item" *ngIf="organiser.email">
            <i nz-icon nzType="mail" aria-hidden="true"></i>
            <span>{{ organiser.email }}</span>
          </div>
          <div class="contact-item" *ngIf="organiser.phoneNumber">
            <i nz-icon nzType="phone" aria-hidden="true"></i>
            <span>{{ organiser.phoneNumber }}</span>
          </div>
          <div class="contact-item" *ngIf="organiser.websiteUrl">
            <i nz-icon nzType="global" aria-hidden="true"></i>
            <a [href]="organiser.websiteUrl" target="_blank" rel="noopener">{{ organiser.websiteUrl }}</a>
          </div>
          <div class="contact-item" *ngIf="organiser.instagramHandle">
            <i nz-icon nzType="instagram" aria-hidden="true"></i>
            <span>{{ organiser.instagramHandle }}</span>
          </div>
          <div class="contact-item" *ngIf="organiser.facebookUrl">
            <i nz-icon nzType="facebook" aria-hidden="true"></i>
            <a [href]="organiser.facebookUrl" target="_blank" rel="noopener">Facebook</a>
          </div>
        </div>
      </div>

      <!-- Upcoming Events -->
      <div class="section" *ngIf="upcomingEvents.length > 0">
        <h2 class="section-title">Upcoming Events</h2>
        <div class="events-grid">
          <a
            *ngFor="let event of upcomingEvents"
            class="event-card"
            [routerLink]="['/tickets', event.slug, event.uid, event.eventType?.uid]"
          >
            <div class="event-card-body">
              <h3 class="event-name">{{ event.name }}</h3>
              <div class="event-meta">
                <span><i nz-icon nzType="calendar" aria-hidden="true"></i> {{ event.date | date: 'mediumDate' }}</span>
                <span *ngIf="event.location?.description">
                  <i nz-icon nzType="environment" aria-hidden="true"></i> {{ event.location.description }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>

      <!-- Organiser Events (Portfolio) -->
      <div class="section" *ngIf="organiserEvents.length > 0">
        <h2 class="section-title">Organiser Portfolio</h2>
        <div class="events-grid">
          <a
            *ngFor="let event of organiserEvents"
            class="event-card"
            [routerLink]="['/tickets', event.slug, event.uid, event.eventType?.uid]"
          >
            <div class="event-card-body">
              <h3 class="event-name">{{ event.name }}</h3>
              <div class="event-meta">
                <span><i nz-icon nzType="calendar" aria-hidden="true"></i> {{ event.date | date: 'mediumDate' }}</span>
                <span *ngIf="event.location?.description">
                  <i nz-icon nzType="environment" aria-hidden="true"></i> {{ event.location.description }}
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>

      <!-- Empty State -->
      <div class="section" *ngIf="organiserEvents.length === 0 && upcomingEvents.length === 0">
        <p class="empty-text">No events for this organiser at the moment.</p>
      </div>
    </div>
  </nz-spin>
</div>
